import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Portfolio from "./pages/Portfolio";
import HoneyBuddy from "./pages/HoneyBuddy";
import SMT from "./pages/SMT";
import CDM from "./pages/CDM";
import Cakery from "./pages/Cakery";
import TaskBuddy from "./pages/TaskBuddy";
import Webcrack from "./pages/Webcrack";
import Memolog from "./pages/Memolog";
import ACMW from "./pages/ACMW";
import About from "./pages/About";

const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.4 } },
  exit: { opacity: 0, transition: { duration: 0.2 } },
};

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        variants={pageVariants}
        initial="initial"
        animate="animate"
        exit="exit"
      >
        <Routes location={location}>
          <Route path="/" element={<Portfolio />} />
          <Route path="/honeybuddy" element={<HoneyBuddy />} />
          <Route path="/smt" element={<SMT />} />
          <Route path="/cdm" element={<CDM />} />
          <Route path="/cakery" element={<Cakery />} />
          <Route path="/taskbuddy" element={<TaskBuddy />} />
          <Route path="/memolog" element={<Memolog />} />
          <Route path="/webcrack" element={<Webcrack />} />
          <Route path="/acmw" element={<ACMW />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
};

function App() {
  return (
    <div className="App">
      <Router>
        <AnimatedRoutes />
      </Router>
    </div>
  );
}

export default App;
